// extracted by mini-css-extract-plugin
export default {"noData":"AHZIM","skeletonWrapper":"STmv1"};